var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M18.2329 20.8376C18.2329 23.1428 17.2301 25.2265 15.6282 26.6461C14.2478 27.8964 12.4245 28.6517 10.4188 28.6517C6.10806 28.6517 2.60474 25.1484 2.60474 20.8376C2.60474 17.2431 5.05316 14.1956 8.36113 13.297C9.25975 15.5631 11.1872 17.3082 13.5705 17.9594C14.2217 18.1417 14.9119 18.2329 15.6282 18.2329C16.3445 18.2329 17.0348 18.1417 17.686 17.9594C18.0376 18.845 18.2329 19.8218 18.2329 20.8376Z",
    fill: "#5030E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4424 10.4188C23.4424 11.4346 23.2471 12.4114 22.8954 13.297C21.9968 15.5631 20.0693 17.3082 17.686 17.9594C17.0349 18.1417 16.3446 18.2329 15.6283 18.2329C14.912 18.2329 14.2218 18.1417 13.5706 17.9594C11.1873 17.3082 9.25982 15.5631 8.3612 13.297C8.00956 12.4114 7.81421 11.4346 7.81421 10.4188C7.81421 6.10802 11.3175 2.6047 15.6283 2.6047C19.9391 2.6047 23.4424 6.10802 23.4424 10.4188Z",
    fill: "#5030E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.6517 20.8376C28.6517 25.1484 25.1484 28.6517 20.8376 28.6517C18.832 28.6517 17.0087 27.8964 15.6282 26.6461C17.2301 25.2265 18.2329 23.1428 18.2329 20.8376C18.2329 19.8218 18.0375 18.845 17.6859 17.9594C20.0692 17.3082 21.9967 15.5631 22.8953 13.297C26.2033 14.1956 28.6517 17.2431 28.6517 20.8376Z",
    fill: "#5030E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b22f04b66a4a6b12aa914e453130c117.svg";
export { ForwardRef as ReactComponent };